import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { CITY_PAGES } from "@/lib/locations";
import { SITE } from "@/lib/site";
import useSEO from "@/hooks/useSEO";

export default function ServiceAreas() {
  useSEO({
    title: "Service Areas · Signs & Wraps across Toronto and the GTA",
    description: "We deliver custom signs, architectural wraps, window film, and vinyl installation across Toronto, Mississauga, Brampton, Vaughan, Markham, and Scarborough. Choose your city.",
    path: "/service-areas",
  });

  // Group pages by city
  const grouped = CITY_PAGES.reduce((acc, p) => {
    (acc[p.city] = acc[p.city] || []).push(p);
    return acc;
  }, {});
  const cities = Object.keys(grouped);

  return (
    <>
      <section className="pt-36 pb-16 bg-ink-950 border-b border-white/5" data-testid="service-areas-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="eyebrow gold-bar">Service areas</div>
          <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Toronto &amp; the GTA.</h1>
          <p className="text-white/60 max-w-2xl mt-5 text-lg">Choose your city for service-specific pricing, project examples, and local install schedules.</p>
        </div>
      </section>

      <section className="py-20 bg-ink-950">
        <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-14">
          {cities.map(city => (
            <div key={city} data-testid={`city-group-${city.toLowerCase()}`}>
              <div className="flex items-center gap-3 mb-6">
                <MapPin className="text-gold" size={18}/>
                <h2 className="font-display text-3xl md:text-4xl">{city}</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {grouped[city].map(p => (
                  <Link key={p.slug} to={`/${p.slug}`} data-testid={`area-link-${p.slug}`} className="card-dark p-6 flex items-center justify-between group">
                    <div>
                      <div className="text-[10px] uppercase tracking-[0.25em] text-gold">{p.serviceSlug.replace("-", " ")}</div>
                      <div className="text-white mt-1 font-medium">{p.title}</div>
                    </div>
                    <ArrowUpRight className="text-white/40 group-hover:text-gold transition-colors" size={18}/>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-ink-900 border-t border-white/5">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <div className="eyebrow">Don't see your city?</div>
          <h2 className="font-display text-3xl md:text-4xl mt-3 tracking-tight">We still serve you.</h2>
          <p className="text-white/60 mt-5">{SITE.areas.join(" · ")} and surrounding GTA areas — request a quote and we'll confirm scheduling.</p>
          <Link to="/contact" className="btn-gold mt-8 inline-flex">Request a quote <ArrowUpRight size={14}/></Link>
        </div>
      </section>
    </>
  );
}
